import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-icon-study',
    templateUrl: './study.component.svg',
    styleUrls: ['./study.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StudyComponent {}
